import React from 'react';
import { makeStyles, Typography } from '@popmenu/common-ui';
import type { StyleRules } from '~/utils/withStyles';
import Grid from '../../../../shared/Grid';
import CongratsSvg from '../../../../assets/svg/congrats.svg';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    textAlign: 'center',
  },
} as const satisfies StyleRules));

type Props = {
  congratulations: {
    header: React.ReactNode;
    body: React.ReactNode;
  };
};

const CongratulationsContent = ({ congratulations }: Props) => {
  const classes = useStyles();
  return (
    <Grid container direction="column" alignContent="center" justifyContent="center" className={classes.root}>
      <Grid item>
        <div data-testid="congrats-svg">
          <CongratsSvg width={'100%'} />
        </div>
      </Grid>
      <Grid item>
        <Typography variant="h6">
          {congratulations.header}
        </Typography>
      </Grid>
      <Grid item>
        <Typography>
          {congratulations.body}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CongratulationsContent;
